// LicensePlateInput.jsx
import React, { useState } from 'react';
import './LicensePlateInput.css';
import { plateFormats } from '../utils/plateFormats.js';

const LicensePlateInput = ({ plateNumber, setPlateNumber, nickname, setNickname, format, isTaxi, setIsTaxi, isElectric, setIsElectric }) => {

  // Dinamikus háttérszín
  const getPlateBackground = () => {
    if (isTaxi & !isElectric) return '#FFD700';
    if (isElectric) return '#88c162';
    return '#fff';
  };


  const selectedFormat = plateFormats.find((f) => f.id === format.id);
  const placeholder = selectedFormat ? selectedFormat.placeholder : '';
  const flagIcon = selectedFormat ? selectedFormat.flagicon : '';

  return (

    <div className="license-plate-input">
      <div className="form-wrapper">
        <div
          className='plate-visual'
          style={{ backgroundColor: getPlateBackground() }}
        >
          <div className="left-section" style={{ backgroundColor: getPlateBackground() }}>
            <img src={flagIcon} className='flag-icon'></img>

            {selectedFormat?.id === 'classic' && (
              <span className="country-code">H</span>
            )}

          </div>
          {selectedFormat?.id === 'classic' && (
            <div className="separator-line"></div>
          )}
          <input
            type="text"
            value={plateNumber}
            onChange={(e) => setPlateNumber(e.target.value.toUpperCase())}
            className="plate-input"
            placeholder={placeholder}
            style={{ backgroundColor: getPlateBackground() }}
          />
        </div>
        <div className="nickname-group">
          <label htmlFor="nickname">Becenév:</label>
          <input
            type="text"
            id="nickname"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="Pl. Fecske"
          />
          <div className="input-info-note">
            <span className="info-icon" aria-hidden="true">ℹ️</span>
            <p>
              Legyél keresztapa, adj nevet az autódnak a rendszáma alapaján! Mi megmutatjuk, hogy a többiek mennyire voltak kreatívak!
            </p>
          </div>
        </div>
        <hr />

        <div className="checkbox-group">
          <div className="checkbox-item">
            <input
              type="checkbox"
              id="taxi"
              checked={isTaxi}
              onChange={(e) => setIsTaxi(e.target.checked)}
            />
            <label htmlFor="taxi">Taxis vagyok</label>
          </div>
          <div className="checkbox-item">
            <input
              type="checkbox"
              id="electric"
              checked={isElectric}
              onChange={(e) => setIsElectric(e.target.checked)}
            />
            <label htmlFor="electric">Elektromos autóm van</label>
          </div>
        </div>
      </div>
    </div>

  );
};

export default LicensePlateInput;
